import type { AuthenticatorDataContainer } from "./AuthenticatorDataContainer";

export class AuthenticatorDataContainerImpl implements AuthenticatorDataContainer {
    #accountSid: string;

    get accountSid(): string {
        return this.#accountSid;
    }

    set accountSid(accountSid: string) {
        this.#accountSid = accountSid;
    }
}

let instance: AuthenticatorDataContainer;
export const getAuthenticatorDataContainerImplInstance: () => AuthenticatorDataContainer = () => {
    instance = instance || new AuthenticatorDataContainerImpl();
    return instance;
};
